import qs from 'qs'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'
import { Alert, Card, CardBody, Col, Container, Row, Spinner } from 'reactstrap'
import auth from '../../api/auth/hooks'
import logoLight from '../../assets/images/dimedia-crm-logo-white.png'
import { selectIsAuthenticated } from '../../store/auth'
import AuthLayout from './AuthLayout'

const Impersonation = () => {
    const location = useLocation()
    const history = useHistory()

    const isAuthenticated = useSelector(selectIsAuthenticated)

    const { data: agentHomepage, isPending } = auth.CurrentAgent.useQuery({ 
        enabled: isAuthenticated, 
        select: (data) => data.agentHomepage 
    })
    const { mutate: impersonate, error } = auth.Impersonate.useMutation()
    
    const errorMessage = error ? error.response?.data?.error || error.message : null

    // Effect to handle impersonation request
    useEffect(() => {
        const params = qs.parse(location.search, { ignoreQueryPrefix: true })
        const token = params.token as string
        const parsedToken = sessionStorage.getItem('parsed_token')

        if (!token) {
            history.replace('/login')
            return
        }

        if (parsedToken === token) return

        sessionStorage.setItem('parsed_token', token)

        impersonate({ token })
    }, [location.search, history, impersonate])

    // Effect to redirect to homepage after successful impersonation
    useEffect(() => {
        if (isAuthenticated && !isPending) {
            const homepage = agentHomepage || '/properties'

            sessionStorage.removeItem('parsed_token')

            history.replace(homepage)
        }
    }, [isAuthenticated, isPending, agentHomepage, history])

    return (
        <AuthLayout>
            <div className="auth-page-content">
                <Container>
                    <Row className="mt-4">
                        <Col lg={12}>
                            <div className="text-center mt-5 mb-5 text-white-50">
                                <div>
                                    <img src={logoLight} alt="" />
                                </div>
                            </div>
                        </Col>
                    </Row>

                    <Row className="justify-content-center">
                        <Col md={8} lg={6} xl={5}>
                            <Card className="mt-5">
                                <CardBody className="p-4">
                                    <div className="text-center mt-2">
                                        <h5 className="fs-16">{error ? 'Greška prilikom impersonacije' : 'Impersonacija u tijeku'}</h5>
                                        <p className={`${error ? 'text-danger' : 'text-muted'} mt-3 fw-bold`}>
                                            {error ? `Status: ${error.response?.status}` : 'Učitavanje...'}
                                        </p>
                                    </div>

                                    {error ? (
                                        <Alert color="danger" className="text-center mt-3" fade={false}>
                                            {errorMessage}
                                        </Alert>
                                    ) : (
                                        <div className="text-center mt-4">
                                            <Spinner color="primary" />
                                        </div>
                                    )}
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </AuthLayout>
    )
}

export default Impersonation
